function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/**
 * An HTTP endpoint, which knows how to handle one or more HTTP methods.
 * Returns `405 - Method Not Allowed` errors for unknown methods,
 * and adds a default `OPTIONS` handler if needed.
 */
function pickMethod(methods) {
  // Uppercase the method names:
  var cleanMethods = {};

  for (var _i = 0, _Object$keys = Object.keys(methods); _i < _Object$keys.length; _i++) {
    var name = _Object$keys[_i];
    cleanMethods[name.toUpperCase()] = methods[name];
  } // Add a default OPTIONS handler:


  if (cleanMethods.OPTIONS == null) {
    cleanMethods.OPTIONS = function () {
      return {
        status: 204,
        headers: optionsHeaders
      };
    };
  }

  var optionsHeaders = {
    'content-length': '0',
    allow: Object.keys(cleanMethods).join(', ')
  };
  return function (request) {
    var handler = cleanMethods[request.method];
    if (handler != null) return handler(request);
    return {
      status: 405,
      headers: optionsHeaders
    };
  };
}
/**
 * A router, which picks a server based on a URL.
 */

function pickPath(routes, fallback) {
  if (fallback === void 0) {
    fallback = function fallback() {
      return {
        status: 404
      };
    };
  }

  // Convert the routes to regular expressions:
  var table = [];

  for (var _i2 = 0, _Object$keys2 = Object.keys(routes); _i2 < _Object$keys2.length; _i2++) {
    var route = _Object$keys2[_i2];
    table.push({
      regexp: new RegExp("^" + route + "$"),
      server: routes[route]
    });
  }

  return function (request) {
    for (var _iterator = _createForOfIteratorHelperLoose(table), _step; !(_step = _iterator()).done;) {
      var _step$value = _step.value,
          regexp = _step$value.regexp,
          server = _step$value.server;
      if (regexp.test(request.path)) return server(request);
    }

    return fallback(request);
  };
}

/**
 * Adds CORS headers to OPTIONS responses.
 */
var withCors = function withCors(server) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (request) {
      var response = yield server(request);
      var _response$headers = response.headers,
          headers = _response$headers === void 0 ? {} : _response$headers;
      return _extends({}, response, {
        headers: _extends({}, headers, {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': 'Accept, Authorization, Content-Type',
          'Access-Control-Allow-Methods': 'DELETE, GET, OPTIONS, POST, PUT'
        })
      });
    });

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

var utf8 = {
  parse: function parse(text) {
    var byteString = encodeURI(text);
    var out = new Uint8Array(byteString.length); // Treat each character as a byte, except for %XX escape sequences:

    var di = 0; // Destination index

    for (var i = 0; i < byteString.length; ++i) {
      var c = byteString.charCodeAt(i);

      if (c === 0x25) {
        out[di++] = parseInt(byteString.slice(i + 1, i + 3), 16);
        i += 2;
      } else {
        out[di++] = c;
      }
    } // Trim any over-allocated space (zero-copy):


    return out.subarray(0, di);
  },
  stringify: function stringify(data) {
    // Create a %XX escape sequence for each input byte:
    var byteString = '';

    for (var i = 0; i < data.length; ++i) {
      var _byte = data[i];
      byteString += '%' + (_byte >> 4).toString(16) + (_byte & 0xf).toString(16);
    }

    return decodeURIComponent(byteString);
  }
};

/**
 * The specific serverlet request type `makeFetchFunction` expects.
 */

/**
 * Wraps a serverlet function in the fetch API.
 */
function makeFetchFunction(serverlet) {
  return /*#__PURE__*/function () {
    var _fetch = _asyncToGenerator(function* (uri, opts) {
      if (opts === void 0) {
        opts = {};
      }

      var _opts = opts,
          _opts$body = _opts.body,
          body = _opts$body === void 0 ? '' : _opts$body,
          _opts$method = _opts.method,
          method = _opts$method === void 0 ? 'GET' : _opts$method,
          _opts$headers = _opts.headers,
          headers = _opts$headers === void 0 ? {} : _opts$headers;

      var _URL = new URL(uri),
          host = _URL.host,
          pathname = _URL.pathname,
          search = _URL.search;

      var request = {
        method: method,
        path: pathname + search,
        version: 'HTTP/1.1',
        headers: _extends({}, headers, {
          host: host
        }),
        body: typeof body === 'string' ? utf8.parse(body) : new Uint8Array(body)
      };
      var response = yield serverlet(request);
      return makeFetchResponse(response);
    });

    function fetch(_x, _x2) {
      return _fetch.apply(this, arguments);
    }

    return fetch;
  }();
}
/**
 * Turns a serverlet response into a fetch-style `Response` object.
 */

function makeFetchResponse(response) {
  var _response$body = response.body,
      body = _response$body === void 0 ? '' : _response$body,
      _response$headers = response.headers,
      headers = _response$headers === void 0 ? {} : _response$headers,
      _response$status = response.status,
      status = _response$status === void 0 ? 200 : _response$status; // Use a promise wrapper to make all exceptions async:

  var bodyPromise = Promise.resolve(body);
  var out = {
    headers: makeFetchHeaders(headers),
    ok: status >= 200 && status < 300,
    status: status,
    arrayBuffer: function arrayBuffer() {
      return _asyncToGenerator(function* () {
        return yield bodyPromise.then(function (body) {
          return typeof body === 'string' ? utf8.parse(body).buffer : body;
        });
      })();
    },
    json: function json() {
      return _asyncToGenerator(function* () {
        return yield out.text().then(function (text) {
          return JSON.parse(text);
        });
      })();
    },
    text: function text() {
      return _asyncToGenerator(function* () {
        return yield bodyPromise.then(function (body) {
          return typeof body === 'string' ? body : utf8.stringify(new Uint8Array(body));
        });
      })();
    }
  };
  return out;
}
/**
 * Turns a simple key-value map into a fetch-style `Headers` object.
 */

function makeFetchHeaders(headers) {
  var out = {
    forEach: function forEach(callback, thisArg) {
      for (var _i = 0, _Object$keys = Object.keys(headers); _i < _Object$keys.length; _i++) {
        var _name = _Object$keys[_i];
        callback.call(thisArg, headers[_name], _name);
      }
    },
    get: function get(name) {
      if (!out.has(name)) return null;
      return headers[name];
    },
    has: function has(name) {
      return Object.prototype.hasOwnProperty.call(headers, name);
    }
  };
  return out;
}

export { makeFetchFunction, makeFetchResponse, pickMethod, pickPath, withCors };
